export const isUserTyping = () => {
    const activeElement = document.activeElement;
    if (!activeElement) {
        return false;
    }

    return ['INPUT', 'TEXTAREA'].includes(activeElement.tagName);
};
